import React from 'react';
import { DepositSettingsCard } from '../provider/DepositSettingsCard';

// Deposit step, sits between Service Type (step 2) and Categories (step 3).
// Uses the first draft service's price for a realistic preview if one exists,
// otherwise falls back to the card's internal default.
export function DepositStep({ form, setForm }) {
  const firstServicePrice =
    (form.draft_services || []).find((s) => Number(s.price) > 0)?.price;

  return (
    <div className="space-y-6 animate-fadeIn">
      <div>
        <h2 className="font-heading text-2xl font-medium text-[#1A1A1A] mb-2">
          Deposit preference
        </h2>
        <p className="text-stone-500">
          Decide how much clients pay upfront when they book. You can skip this step if you'd
          rather handle deposits per service, we'll ask again on each service you create.
        </p>
      </div>

      <DepositSettingsCard
        value={form.default_deposit_percent}
        onChange={(next) => setForm({ ...form, default_deposit_percent: next })}
        previewPrice={firstServicePrice}
        cancellationPolicy={form.cancellation_policy}
        showHeading={false}
        testIdPrefix="onboarding-deposit"
      />
    </div>
  );
}
